export default __webpack_public_path__ + "static/media/7.5ece79ca.png";